'use client'

import { useEffect } from 'react'

import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { ViewLandingPageEvent } from '@marketplace-web/marketing-campaigns/marketing-landing-page-data'

import IntroductionSection from './components/IntroductionSection/IntroductionSection'
import TaxRulesSection from './components/TaxRulesSection/TaxRulesSection'
import ApplySection from './components/ApplySection/ApplySection'
import HowItWorksSection from './components/HowItWorksSection/HowItWorksSection'
import CheckStatusSection from './components/CheckStatusSection/CheckStatusSection'
import LinksSection from './components/LinksSection/LinksSection'
import { DAC7_URL } from '../../constants/routes'

const DacSeven = () => {
  const { track } = useTracking()

  useEffect(() => {
    track(
      ViewLandingPageEvent({
        screen: 'dac7',
        path: DAC7_URL,
        referrer: document.referrer ? new URL(document.referrer).href : 'unknown',
      }),
    )
  }, [track])

  return (
    <div className="dac7__wrapper">
      <IntroductionSection />
      <TaxRulesSection />
      <ApplySection />
      <HowItWorksSection />
      <CheckStatusSection />
      <LinksSection />
    </div>
  )
}

export default DacSeven
